export default "__VITE_ASSET__BAUybskB__"